<div [class]="notificationClass">
  @if (icon) {
    <figure class="sh-notification__icon">
      @if (icon) {
        <svg sh-icon [name]="icon"></svg>
      }
    </figure>
  }

  <div class="sh-notification__content">
    @if (title) {
      <h4 class="sh-notification__title"><sh-html-parser [message]="title"></sh-html-parser></h4>
    }
    <p class="sh-preserve-linebreaks sh-notification__msg"><sh-html-parser [message]="message"></sh-html-parser></p>

    @if (messageList) {
      @for (submessage of messageList; track submessage) {
        <ul class="sh-notification__msg">
          <li class="sh-clear-margin"><sh-html-parser [message]="submessage"></sh-html-parser></li>
        </ul>
      }
    }

    @if (linkList) {
      @for (subLink of linkList; track subLink.label) {
        <div class="sh-notification__msg" style="margin-top: 1rem">
          @if (subLink.navigationLink) {
            <a [shNavigationLink]="subLink.navigationLink" class="sh-link">{{ subLink.label }}</a>
          }
        </div>
      }
    }
  </div>

  @if (closable) {
    <button type="button" class="sh-pure-icon-button sh-notification__close-button" aria-label="close" (click)="onClose()">
      <svg sh-icon class="sh-icon-button__icon" [name]="'close'"></svg>
    </button>
  }
</div>
